import styled from 'styled-components';

export const PositionWrapper = styled.div`
  font-size: ${props => (props.size ? `${props.size}em` : '1em')};
  line-height: 2;
  background: ${props => (props.bgColor ? props.theme.colors[props.bgColor] : 'transparent')};
  height: 2em;
  width: 1.5em;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/components/shared/PositionMarker/styles.js